import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BnEmptyPipe } from './bn-empty.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [BnEmptyPipe],
  exports: [BnEmptyPipe],
})
export class BnEmptyPipeModule {}
